var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('h3',{staticClass:"mb-4"},[_vm._v("Vehicles Uploads")]),_c('SharedTable',{attrs:{"fields":_vm.fields,"items":_vm.items,"options":_vm.options,"busy":_vm.loading},on:{"getSelectedItems":_vm.getSelectedItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }